import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    shareId,
    token,
    username,
    password,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.projectShare.login, {
        shareId,
        token,
        username,
        password,
    }, options);
    if (error) return { error, status };
    return content || {};
};
